import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import propMessages from './messages/ContactPersonProps_messages';

import { InfoList, InfoRow, Key, Value } from '../../components/InfoList';

const propTypes = {
  contactPerson: PropTypes.object.isRequired,
};

const ContactPersonInfo = ({ contactPerson }) =>
  <InfoList id={`contact-person-${contactPerson.id}-info`}>
    <InfoRow id="contact-person-info-first-name">
      <Key>
        <label>
          <FormattedMessage { ...propMessages.firstNameLabel } />
        </label>
      </Key>
      <Value>{contactPerson.firstName}</Value>
    </InfoRow>
    <InfoRow id="contact-person-info-last-name">
      <Key>
        <label>
          <FormattedMessage { ...propMessages.lastNameLabel } />
        </label>
      </Key>
      <Value>{contactPerson.lastName}</Value>
    </InfoRow>
    <InfoRow id="contact-person-info-phone">
      <Key>
        <label>
          <FormattedMessage { ...propMessages.phoneLabel } />
        </label>
      </Key>
      <Value>{contactPerson.phone}</Value>
    </InfoRow>
    <InfoRow id="contact-person-info-email">
      <Key>
        <label>
          <FormattedMessage { ...propMessages.emailLabel } />
        </label>
      </Key>
      <Value>{contactPerson.email}</Value>
    </InfoRow>
  </InfoList>;

ContactPersonInfo.propTypes = propTypes;

export default ContactPersonInfo;
